import { formatCalendarDate } from './calendarSystem';
import { formatInTimeZone } from 'date-fns-tz';
import { clockForCalendar, clockForTimezone } from './clockSystem';
export function getBookingDisplayClock(fallback = 'gregory') {
  try {
    const requested = new URLSearchParams(window.location.search).get('clock');
    if (['standard', 'ethiopian', 'both'].includes(requested)) return clockForTimezone(requested, getBookingTimezone());
    const stored = localStorage.getItem('bookingDisplayClock');
    return clockForTimezone(['standard', 'ethiopian', 'both'].includes(stored) ? stored : clockForCalendar(getBookingDisplayCalendar(fallback)), getBookingTimezone());
  }
  catch { return 'standard'; }
}
export function scheduleDateLabel(value, bookingType, fallbackTimezone = 'UTC', displayCalendar) {
  if (!value) return '';
  const day = /^\d{4}-\d{2}-\d{2}$/.test(String(value)) ? String(value) : formatInTimeZone(new Date(value), bookingType?.scheduleTimezone || fallbackTimezone, 'yyyy-MM-dd');
  return displayBookingDate(day, displayCalendar || bookingType?.calendarSystem || 'gregory');
}
export function displayBookingDate(civilDate, calendar = 'gregory') {
  return calendar === 'ethiopic' ? `${formatCalendarDate(civilDate, 'ethiopic')} / ${formatCalendarDate(civilDate, 'gregory')} (Gregorian)` : formatCalendarDate(civilDate, 'gregory');
}
export function getBookingDisplayCalendar(fallback = 'gregory') {
  try {
    const requested = new URLSearchParams(window.location.search).get('calendar');
    if (['gregory', 'ethiopic'].includes(requested)) return requested;
    const stored = localStorage.getItem('bookingDisplayCalendar');
    return ['gregory', 'ethiopic'].includes(stored) ? stored : fallback;
  } catch { return fallback; }
}
export function getBookingTimezone(fallback = 'UTC') {
  const valid = value => { if (!value) return false; try { new Intl.DateTimeFormat('en-US', { timeZone: value }); return true; } catch { return false; } };
  try {
    const requested = new URLSearchParams(window.location.search).get('timezone');
    if (valid(requested)) return requested;
    const stored = localStorage.getItem('timezone');
    if (valid(stored)) return stored;
  } catch { /* Storage may be unavailable. */ }
  return valid(fallback) ? fallback : 'UTC';
}
export function rememberCheckoutDisplay(calendar, clock, timezone = getBookingTimezone()) {
  try { sessionStorage.setItem('timely-checkout-display', JSON.stringify({ calendar, clock, timezone })); } catch { /* Optional display preference. */ }
}
export function getCheckoutDisplay(fallbackCalendar = 'gregory') {
  try {
    const saved = JSON.parse(sessionStorage.getItem('timely-checkout-display') || 'null');
    if (['gregory', 'ethiopic'].includes(saved?.calendar) && ['standard', 'ethiopian', 'both'].includes(saved?.clock)) return { calendar: saved.calendar, clock: clockForTimezone(saved.clock, saved.timezone || getBookingTimezone()) };
  } catch { /* Fall back when storage is unavailable or invalid. */ }
  return { calendar: getBookingDisplayCalendar(fallbackCalendar), clock: getBookingDisplayClock(fallbackCalendar) };
}
